export const settingsTabs = [
  {
    name: 'Team Settings',
    value: 'teamSettings',
  },
  {
    name: 'Integrations',
    value: 'integrations',
  },
  // TODO: Re-enable Performance Settings tab in a month
  // {
  //   name: 'Performance Settings',
  //   value: 'performanceSettings',
  // },
];
